<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Template Reference </ng-container>
    <ng-container cm-content>
        <cm-template-thumbnail [template]="$node()"></cm-template-thumbnail>
        @if ($templateId() !== undefined) {
            <cm-value-slot
                [node]="$node()"
                [key]="'templateRevisionId'"
                [label]="'Latest revision'"
                [schema]="$boolean()"
                [overwrittenValue]="$autoUpdate()"
                (updatedOverwrittenValue)="onChangeAutoUpdate($event)"
            ></cm-value-slot>
        }
        @if (!$autoUpdate()) {
            <div class="cm-template-revision-settings">
                @if ($node(); as templateReference) {
                    <cm-value-slot
                        [node]="templateReference"
                        [key]="'templateRevisionId'"
                        [label]="'Revision'"
                        [selectionPossibilities]="$revisionPossibilities()"
                        [schema]="$number()"
                    ></cm-value-slot>

                    @if ($latestTemplateRevisionId() !== undefined && $latestTemplateRevisionId() !== $templateRevisionId()) {
                        <cm-button class="cm-action-button" (click)="updateToLatestTemplateRevision()">
                            <ng-container cm-text> <i class="far fa-arrow-up"></i> Update </ng-container>
                        </cm-button>
                    } @else {
                        <div class="cm-latest"><i class="far fa-check"></i>Latest</div>
                    }
                }
            </div>
        }
    </ng-container>
</cm-inspector-section>
